import { Grid } from '@material-ui/core';
import { rippleStyles } from '@ncr-retail/base-retail-components';
import React from 'react';
import { IButton } from 'src/common/interfaces/IButton';
import SizedGridItem from 'src/sized-grid-item/sized-grid-item';
import KeypadButton from '../keypad-button/keypad-button';
import { keypadBottomButtonsStyles } from './keypad-bottom-buttons-styles';

const KeypadBottomButtons: React.FC<IKeypadBottomButtonsProps> = (
  props: IKeypadBottomButtonsProps,
): JSX.Element => {
  const classes = keypadBottomButtonsStyles();
  const ripple = rippleStyles();
  return (
    <Grid item className={`${classes.keypadBottomButtons} fullWidth`}>
      <Grid
        container
        justifyContent='space-between'
        alignContent='flex-end'
        className={`fullHeight`}
      >
        <SizedGridItem size='100%'>
          <KeypadButton
            className={`${classes.keypadActionButton} ${ripple.containedButton}`}
            dataTestId={
              props.submitButton.testId ? props.submitButton.testId : 'keypad-submit-button'
            }
            onClick={(): void => props.submitButton.onClick()}
            disableButton={props.disableButtons}
          >
            {props.submitButton.label}
          </KeypadButton>
        </SizedGridItem>
      </Grid>
    </Grid>
  );
};

export default KeypadBottomButtons;

export interface IKeypadBottomButtonsProps {
  submitButton: IButton;
  disableButtons: boolean;
}
